import * as React from "react";
import { Bling as GPT } from "react-gpt";
import { adMobileRectangle, adMobileSquare, adPositions, adSkyScraper, adSuperzone, adUnits, adViewports, generateAdTargeting, } from "../../utils/ads";
export var AdUnitSideRail = function (_a) {
    var adUnit = _a.adUnit, targeting = _a.targeting;
    return (React.createElement(GPT, { adUnitPath: adUnits[adUnit], sizeMapping: [
            { viewport: adViewports.mobile, slot: [adMobileRectangle, adMobileSquare, adSuperzone] },
            { viewport: adViewports.tablet, slot: [adMobileSquare, adSuperzone] },
            { viewport: adViewports.laptop, slot: [adMobileSquare, adSkyScraper] },
        ], targeting: generateAdTargeting(Object.assign({}, targeting, {
            position: adPositions.sideRail,
        })) }));
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/ad/adUnitSideRail.tsx
// module id = sbiH
// module chunks = 2